import "./BakeryAndPastry.module.css";
import Header from "@/reusable_sections/Header";
import Bakeryshowcase from "./sections/Bakeryshowcase";
import Eurocontrol from "./sections/Eurocontrol";
import BakeryshowcaseCopy from "./sections/BakeryshowcaseCopy";
import Footer from "@/reusable_sections/Footer";
export default function BakeryAndPastryPage() {
  return <div>
      <Header />
      <Bakeryshowcase />
      <BakeryshowcaseCopy />
      <Eurocontrol />
      <Footer />
    </div>;
}